import React from 'react';
import { useDispatch } from 'react-redux';

import {
  createMessageConsumer,
  exportMessagesConsumer,
  getIdeasMessagesConsumer,
} from '../../../../redux/consumer/id8/consumerId8Actions';
import CommonMessagesOutput from '../common-messages-output/CommonMessagesOutput';
import MessageFilters from '../../../../id8/components/ideas/message-filters/MessageFilters';
import MessagesGeneratingConsumerStatusController from '../generating-status-controller/MessagesGeneratingConsumerStatusController';

import scss from '../../Id8.module.scss';

function IdeasTab({ bindAction, isShowGenerationForm }) {
  const dispatch = useDispatch();

  const handleSearchIdeasMessages = () => {
    dispatch(getIdeasMessagesConsumer());
  };

  return (
    <div className={scss.outputWrapper}>
      <MessageFilters onExportMessages={exportMessagesConsumer} onCreateMessage={createMessageConsumer} />

      <CommonMessagesOutput
        bindAction={bindAction}
        searchFunction={handleSearchIdeasMessages}
        isShowGenerationForm={isShowGenerationForm}
      />

      <MessagesGeneratingConsumerStatusController />
    </div>
  );
}

export default IdeasTab;
